<template>
    <div class="editor-component">
        <TextareaComponent 
        ref="textarea"
        :pickerStyle="pickerStyle"
        :text="textHtml"
        :charactersLength="charactersLength"
        :maxCharacters="maxCharacters"
        :ShowCounterCharacters="ShowCounterCharacters"
        :textInfoMaxCharacters="textInfoMaxCharacters"
        :showOptionBold="showOptionBold"
        :showOptionItalic="showOptionItalic"
        :compactOption="compactOption"
        :disableHashtag="!this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)"
        :disableMention="!this.pagesSelected.find(p => ['facebook','instagram','linkedin', 'twitter','bluesky'].includes(p.network) || (p.network == 'tiktok' && p.story_config && p.story_config.created))"
        @newMention="newMention"
        @editMention="editMention"
        @newHashtag="newHashtag"
        @change="changeText"
        @updateMentionLabel="updateMentionLabel"
        v-bind="$attrs"
        v-on="$listeners"
        />
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import TextareaComponent from './Textarea.vue'
import minxinBot from '@/components/mixins/Bots.vue'
import Fonts from '@/utils/Fonts'

export default {
    components: {
        TextareaComponent,
    },
    mixins: [minxinBot],
    
    props: {
        id: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        mentions: {
            type: Object,
            default: ()=>({})
        },
        
        maxCharacters: {
            type: Number,
            default: Infinity
        },
        
        textInfoMaxCharacters:{
            type: String,
            default: ''
        },
        compactOption: {
            type: Boolean,
            default: false
        },
        showOptionBold: {
            type: Boolean,
            default: true
        },
        showOptionItalic: {
            type: Boolean,
            default: true
        },
        showOptionUnderline: {
            type: Boolean,
            default: true
        }, 
        ShowCounterCharacters: {
            type: Boolean,
            default: true
        },
        pickerStyle:{
            type: String,
            default: ''
        },
        
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },
        
        personalizationMode : {
            type: Boolean,
            default: false
        },
    },
    
    data() {
        return {
            textHtml: '',
            _isEditorUpdate: false,
        }
    },
    
    created () {
        if (this.text) this.textHtml = this.textToHTML(this.text)
    },
    
    
    watch: {
        text: {
            immediate: true,
            handler(newValue, oldValue) {
                if (this._isEditorUpdate) {
                    this._isEditorUpdate = false
                } else {
                    this.textHtml = this.textToHTML(this.text)
                    console.log('pres setContent',this.$refs)
                    this.$refs.textarea.setContent(this.textHtml)
                }
            }
        }
    },
    
    
    methods: {
        newHashtag({resolve}) {
            if (this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)) {
                this.addMode("addHashtagMode", {
                    searchHashtags: this.searchHashtags,
                    apply: (hashtags) => {
                        resolve(hashtags)
                    },
                })
            }   
        },
        newMention({text = '', resolve}) {
            const newMentionId = Date.now()
            
            this.$emit('setMention', newMentionId, {
                textDefault : text,
                mention : {}
            })
            
            this.addMode("addMentionMode", {
                idMention: newMentionId,
                networks: this.personalizationMode ? [this.typeRenderNetworkSelected] : null,
                mentions: this.mentions,
                mention: this.mentions[newMentionId],
                text: text,
                searchMention: this.searchMention,
                addMention: (network, person) => {
                    this.addMention(network, person, newMentionId)
                },
                removeMention: (network) => {
                    this.removeMention(network, newMentionId)
                },
                close: () => {
                    if (Object.keys(this.mentions[newMentionId].mention).length === 0) {
                        this.$delete(this.mentions, newMentionId);
                    } else {
                        resolve({
                            id: newMentionId,
                            text: this.mentions[newMentionId].textDefault
                        })
                    }
                }
            })
            
            
        },
        
        editMention({id, text, resolve}) {
            if (this.mentions[id]) {
                this.addMode("addMentionMode", {
                    idMention: id,
                    networks: this.personalizationMode ? [this.typeRenderNetworkSelected] : null,
                    mentions: this.mentions,
                    mention: this.mentions[id],
                    text: text,
                    searchMention: this.searchMention,
                    addMention: (network, person) => {
                        this.addMention(network, person, id)
                    },
                    removeMention: (network) => {
                        this.removeMention(network, id)
                    },
                    close: () => {
                        if (Object.keys(this.mentions[id].mention).length === 0) {
                            this.$delete(this.mentions, id);
                            resolve({
                                id: null,
                                text: null
                            })
                        } else {
                            resolve({
                                id: id,
                                text: this.mentions[id].textDefault
                            })
                        }
                    }
                })
            }
        },
        
        addMention(network, person, mentionId){
            const isTextDefaultEmpty = !this.mentions[mentionId].textDefault.trim()
            
            const mention = {
                mention : {
                    ...this.mentions[mentionId].mention,
                    [network]: person
                },
                textDefault : isTextDefaultEmpty ? person.name || person.id || '' : this.mentions[mentionId].textDefault
            }
            
            this.$emit('setMention', mentionId, mention)
        },
        
        removeMention(network, mentionId){
            if (this.mentions[mentionId]) {
                this.$delete(this.mentions[mentionId].mention, network);
            }
        },
        
        updateMentionLabel({id, text}) {
            if (this.mentions[id]) {
                this.$set(this.mentions[id], 'textDefault', text)
            }
        },
        
        async searchMention(value, network) {
            
            let page = null
            let isUrl = false
            switch (network) {
                case 'instagram':
                page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'instagram' && p.bot_status)
                break;
                
                case 'facebook':
                page = this.pagesSelected.find(p => p.network == 'facebook' && (p.bot_status || true))
                break;
                
                case 'twitter':
                page = this.pagesSelected.find(p => p.network == 'twitter' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'twitter' && p.bot_status)
                break;
                
                case 'bluesky':
                page = this.pagesSelected.find(p => p.network == 'bluesky' && p.bot_status)
                break;
                
                case 'tiktok':
                page = this.pagesSelected.find(p => p.network == 'tiktok' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'tiktok' && p.bot_status)
                break;
                
                case 'linkedin':
                
                page = this.pagesSelected.find(p => p.network == 'linkedin' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'linkedin' && p.bot_status)
                isUrl = false
                
                if (page) {
                    if (value.includes("linkedin.com/company")) {
                        isUrl = true
                        value = value.split('/')
                        let index = value.findIndex(v => v == 'company')
                        value = value[index+1] || ''
                    }else{
                        if (!page.story_config || !page.story_config.created) {
                            //conciergerie désactivé
                            value = value.replaceAll(' ','-')
                            isUrl = true
                        }
                        
                    }
                }
                
                break;
            }
            
            let result = []
            if (page && value) {
                result = (await this.getMentionsByApi(page.id, value, isUrl, true)).mentions
            }
            return result
        },
        
        async searchHashtags(value, network) {
            let page = null
            switch (network) {
                case 'instagram':
                page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                break;
            }
            
            let result = []
            if (page && value) {
                result = (await this.getHashtagsByApi(page.id, value)).body.hashtags
            }
            return result
        },
        
        addMode(mode, data = {}) {
            EventBus.$emit("postCreatorAddMode", mode, data);
        },
        
        changeText(html) {
            const el = document.createElement('div')
            el.innerHTML = html
            console.log('changeText html', html)


            el.querySelectorAll('br').forEach(br => br.replaceWith('\n'))

            // Mentions → @id
            el.querySelectorAll('.tag-mention').forEach(mention => {
                mention.replaceWith(`@${mention.getAttribute('data-id')}`)
            })
            
            // Italic → unicode
            el.querySelectorAll('em').forEach(em => {
                em.replaceWith(Fonts.italic(em.innerText))
            })
            
            // Bold → unicode
            el.querySelectorAll('strong').forEach(strong => {
                strong.replaceWith(Fonts.bold(strong.innerText))
            })
            
            // Sauts de ligne (paragraphes Tiptap → \n)
            el.querySelectorAll('p').forEach((p, i, arr) => {
                if (i < arr.length - 1) p.after('\n')
            })
            console.log('changeText after format', el.innerText)
            
            let text = el.innerText
            .replace(/@([\d𝟬𝟭𝟮𝟯𝟰𝟱𝟲𝟳𝟴𝟵]{26})/g, (match) => {
                return '@' + Fonts.normalize(match.slice(1))
            })
            
            console.log('changeText', el, text)
            this._isEditorUpdate = true
            this.$emit('setText', text)
            return text
        },       
        
        textToHTML(text) {
            const lines = text.split('\n')
            
            const processLine = (line) => {
                const graphemes = line.match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu) || []
                
                let html = ''
                let currentStyle = null
                let buffer = ''
                
                const flush = (style, content) => {
                    if (!content) return ''
                    const escaped = content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                    switch (style) {
                        case 'bold':        return `<strong>${Fonts.normalize(escaped)}</strong>`
                        case 'italic':      return `<em>${Fonts.normalize(escaped)}</em>`
                        case 'bold-italic': return `<strong><em>${Fonts.normalize(escaped)}</em></strong>`
                        default:            return escaped
                    }
                }
                
                for (const g of graphemes) {
                    const style = Fonts.styledText(g)
                    const normalizedStyle = ['bold', 'italic', 'bold-italic'].includes(style) ? style : 'normal'
                    
                    if (normalizedStyle !== currentStyle) {
                        html += flush(currentStyle, buffer)
                        buffer = ''
                        currentStyle = normalizedStyle
                    }
                    buffer += g
                }
                html += flush(currentStyle, buffer)
                
                // Mentions
                html = html.replace(/@(\d{13})/g, (match, id) => {
                    if (!this.mentions[id]) return match
                    return `<span class="tag-mention" data-id="${id}">@${this.mentions[id].textDefault}</span>`
                })
                
                return html
            }
            
            return `<p>${lines.map(processLine).join('</p><p>')}</p>`
        },
    },
    
    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
        charactersLength() {
            
            const text = this.text.replace(/\\n/g, '\n').replace(/@(\d{13})/g, (match, id) => {
                const mention = this.mentions[id];
                if (mention) {
                    return mention.mention && mention.mention[this.typeRenderNetworkSelected] ? `@${mention.mention[this.typeRenderNetworkSelected].name || mention.mention[this.typeRenderNetworkSelected].id}` : mention.textDefault;
                }
                return match;
            })
            
            switch (this.typeRenderNetworkSelected) {
                case 'twitter':
                
                const twttr = require('twitter-text')
                return this.counterCharacters = twttr.default.parseTweet(text).weightedLength
                
                
                default:
                return text.length
                break;
            }
        },
    },
    
    beforeDestroy() {
        EventBus.$off('eventSearchFromSelectMention', this.searchMention);
    },
}
</script>

<style lang="scss" scoped>

</style>

